<script setup lang="ts">
import type { PropType } from 'vue'
import { ref } from 'vue'
import LoaderSmall from '@/components/Elements/Loaders/LoaderSmall.vue'

const props = defineProps({
  active: {
    type: Boolean,
    default: false
  },
  fullWidth: {
    type: Boolean,
    default: false
  },
  forIcon: {
    type: Boolean,
    default: false
  },
  spinner: {
    type: Boolean,
    default: false
  },
  type: {
    type: String as PropType<'button' | 'submit' | 'reset'>,
    default: 'button'
  },
  color: {
    type: String as PropType<'default' | 'darker' | 'red' | 'green' | 'blue' | 'gray'>,
    default: 'default'
  }
})

/**
 * Variables
 */
const spinning = ref(false)

/**
 * Functions
 */
const clicked = () => {
  if (props.spinner) {
    spinning.value = true
  }
}
</script>

<template>
  <button
    :type="type"
    @click="clicked"
    :class="{
      'py-1 rounded text-metal-300 transition-all duration-100 ease-out': true,
      'btn-3d': true,
      'hover:brightness-110': true,
      'bg-metal-700': active && color === 'default',
      'bg-metal-600': !active && (color === 'default' || color === 'darker'),
      'bg-red-500': color === 'red',
      'bg-green-500': color === 'green',
      'bg-blue-500': color === 'blue',
      'bg-gray-500': color === 'gray',
      'text-white': color === 'red' || color === 'green' || color === 'blue' || color === 'gray',
      'w-full': fullWidth,
      'px-2': !forIcon,
      'px-1': forIcon,
      'cursor-none': spinning
    }"
  >
    <span v-if="spinner && spinning">
      <LoaderSmall />
    </span>
    <span v-if="!spinner || !spinning">
      <slot></slot>
    </span>
  </button>
</template>

<style scoped lang="scss">
.btn-3d {
  background-image: linear-gradient(to bottom, rgba(255,255,255,0.1) 0%, rgba(0,0,0,0.1) 100%);
  box-shadow: 0 2px 0 rgba(0,0,0,0.3);
  transform: translateY(0);

  :deep(img) {
    filter: drop-shadow(0 1px 1px rgba(0,0,0,0.4));
  }

  &:active {
    box-shadow: 0 0 0 rgba(0,0,0,0.3);
    transform: translateY(2px);
  }
}
</style>
